var render, staticRenderFns
import script from "./VuesticTimelineSeparator.vue?vue&type=script&lang=js"
export * from "./VuesticTimelineSeparator.vue?vue&type=script&lang=js"
import style0 from "./VuesticTimelineSeparator.vue?vue&type=style&index=0&id=3279dd9e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3279dd9e')) {
      api.createRecord('3279dd9e', component.options)
    } else {
      api.reload('3279dd9e', component.options)
    }
    
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-timelines/VuesticTimelineSeparator.vue"
export default component.exports